const apiRoot = import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL : 'https://www.classictix.com:8003'

const fetchDataGet = (path) => 
    fetch(path)
    .then((response) => {
        if (!response.ok) {
            let challengeBypassHeader = response.headers.get('cf-chl-bypass')
            if (response.status === 403 && challengeBypassHeader !== null) {
                window.location.reload()
            } else {
                return response.json().then((result) => {
                    throw result
                })
            }
        }
        return response.json()
    })
    .then((result) => {
        return result
    })

const fetchDataPost = (path, opts) => 
    fetch(path, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(opts)
    })
    .then((response) => {
        if (!response.ok) {
            let challengeBypassHeader = response.headers.get('cf-chl-bypass')
            if (response.status === 403 && challengeBypassHeader !== null) {
                window.location.reload()
            } else {
                return response.json().then((result) => {
                    if (result.ExceptionMessage === 'Invalid refresh token') {
                        return false
                    }

                    throw result
                })
            }
        }
        return response.json()
    })
    .then((result) => {
        return result
    })


export const searchEvents = (opts) => fetchDataPost(apiRoot + '/api/search', opts)
export const apiRootUrl = apiRoot